import { api, financeAPI } from "../../axios";

export const actions = {
  GetFundCluster() {
    return api.get("FundCluster/GetAllFundClusters");
  },
  GetSingleFundCluster(context, data) {
    return api.get(`FundCluster/${data}`);
  },
  UpdateFundCluster(context, data) {
    return api.put(`FundCluster/${data.id}`, data);
  },
  DeleteFundCluster(context, data) {
    return api.delete(`FundCluster/${data}`);
  },
  CreateFundCluster(context, data) {
    return api.post(`FundCluster/CreateFundCluster`, data);
  },

  // Fund Cluster Signatory
  GetFundClusterSignatory(context, data) {
    return financeAPI.get(`FundClusterSignatory/All/${data.fundClusterId}/${data.campusId}`);
  },
  UpdateFundClusterSignatory(context, data) {
    return financeAPI.put(`FundClusterSignatory/${data.id}`, data);
  },
  DeleteFundClusterSignatory(context, data) {
    return financeAPI.delete(`FundClusterSignatory/${data}`);
  },
  CreateFundClusterSignatory(context, data) {
    return financeAPI.post(`FundClusterSignatory/Add/${data.campusId}`, data);
  }
};
